import React, { useState, useEffect } from "react";
import axios from "axios";
import { AiFillFilePdf } from "react-icons/ai";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import "./BundleListLealtad.css";
import styles from "../../../views/ReportView/ReportView.module.css";
import ButtonDownload from "./ButtonDownload/ButtonDownload.jsx";

const BundleList = ({ data }) => {
  const [bundleListUser, setBundleListUser] = useState([]);
  const bundlerId = data && data.id ? data.id : null;

  useEffect(() => {
    if (data) {
      const apiUrl = `${process.env.REACT_APP_LEALTAD_GET_LEGAJO}?userId=${bundlerId}`;
      const fetchData = async () => {
        try {
          const response = await axios.get(apiUrl);
          if (response.status === 204) {
            setBundleListUser([]);
          } else {
            setBundleListUser(response.data.userAllLegajo);
          }
        } catch (error) {
          setBundleListUser([]);
        }
      };
      fetchData();
    }
  }, [bundlerId, data]);

  return (
    <div className="ListLegajo" id="Legajo">
      <div className={styles.LealtadsectionTitle2}>
        <h2 className={styles.LealtadsectionTitleH2}>Legajo</h2>
        <IconAnimation />
      </div>
      {!data ? (
        <NotReportViewData title="Legajos" Icon={AiFillFilePdf} />
      ) : (
        <div className="boxlistLegajoleatad">
          <div className="boxDisplayLegajoLealtad">
            <table className={styles.LealtadtableMDR}>
              <thead>
                <tr>
                  <th>Cuil</th>
                  <th>N° Crédito</th>
                  <th>Fecha de subida</th>
                  <th>Descargar</th>
                </tr>
              </thead>
              <tbody>
                {bundleListUser.map((item, index) => (
                  <tr key={index}>
                    <td>{item.cuil}</td>
                    <td>{item.credit}</td>
                    <td>{item.createdAt}</td>
                    <td>
                      <ButtonDownload
                        bundleID={item.id}
                        bundleCuil={item.cuil}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default BundleList;
